import { NgModule } from '@angular/core';

import { FilterPipe } from './filter/filter.pipe';
import { SafePipe } from './safe/safe.pipe';
import { StripHtmlPipe } from './strip-html/strip-html.pipe';
import { InitialsPipe } from './initials/initials.pipe';
import { WordPipe } from './word/word.pipe';
import { JoinPipe } from './join/join.pipe';

@NgModule({
  declarations: [InitialsPipe, FilterPipe, StripHtmlPipe, SafePipe, WordPipe, JoinPipe],
  exports: [InitialsPipe, FilterPipe, StripHtmlPipe, SafePipe, WordPipe, JoinPipe],
})
export class CorePipesModule {}
